import { useLang } from '../i18n'

/**
 * The two selects a PowerPoint template is chosen with: the template and, when it has several, its
 * slide master (an artefact's default template, AB#444; where a PowerPoint import lands, AB#482).
 * `value` is one of `options`, `master` an index in `masters`; a master its author left unnamed reads
 * "Slide master 2". Pass no `masters` where a choice has none to pick from.
 */
export function TemplateMasterSelects({
  label,
  value,
  options,
  masters,
  master,
  disabled,
  onTemplate,
  onMaster,
}: {
  label: string
  value: string
  options: ReadonlyArray<{ value: string; label: string }>
  masters: ReadonlyArray<{ name: string }>
  master: number
  disabled?: boolean
  onTemplate: (value: string) => void
  onMaster: (index: number) => void
}) {
  const { t } = useLang()
  return (
    <>
      <label className="prompt-label">
        {label}
        <select className="prompt-input" value={value} disabled={disabled} onChange={(e) => onTemplate(e.target.value)}>
          {options.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
      </label>
      {masters.length > 1 && (
        <label className="prompt-label">
          {t('tpl_slides_master')}
          <select className="prompt-input" value={master} disabled={disabled} onChange={(e) => onMaster(Number(e.target.value))}>
            {masters.map((m, i) => (
              <option key={i} value={i}>
                {m.name || `${t('tpl_slides_master')} ${i + 1}`}
              </option>
            ))}
          </select>
        </label>
      )}
    </>
  )
}
